import { useOrgInfoStore } from '@store/common/useOrgInfoStore.js'
import { useMemo } from 'react'
import { DEFAULT_USE_TYPE, USE_TYPE } from '@constants/appTarget.js'
import { isAuthExpiredError } from '@utils/isAuthExpiredError.js'

const THROW_ON_ERROR = {
  [USE_TYPE.KBPAY]: true,
  [USE_TYPE.MSTOCK]: isAuthExpiredError,
  [USE_TYPE.jb]: isAuthExpiredError,
  [USE_TYPE.hana]: isAuthExpiredError
}

const resolveThrowOnError = (orgCd) => THROW_ON_ERROR[orgCd] ?? THROW_ON_ERROR[DEFAULT_USE_TYPE]

export const useOrgErrorPolicy = () => {
  const orgCd = useOrgInfoStore((s) => s.useType)

  return useMemo(() => ({ throwOnError: resolveThrowOnError(orgCd) }), [orgCd])
}
